// extracted by mini-css-extract-plugin
export var dividerContainer = "_8a-0";
export var line = "_8a-1";